import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    key: String,
    permanent: Boolean,
    static: Boolean,
    isFlash: Boolean
  }
  connect() {
    document.addEventListener('promote:hide-toast-message', this._removeFromEvent.bind(this));
    document.addEventListener('promote:hide-flash-message', this._removeFlashImmediately.bind(this));

    // Only flash messages should be removed when a page is reloaded
    // If this is done for messages rendered through custom events the timing of the removal can
    // be off in some cases
    if (this.isFlashValue === true &&
      this.keyValue !== "error" &&
      this.keyValue !== "warning" &&
      this.permanentValue === false) {
      this._setTimeoutForRemove();
    }
  }

  _removeFlashImmediately() {
    if (this.isFlashValue) {
      this.remove();
    }
  }

  remove() {
    if (this.staticValue === true) {
      // If action has been added through custom event it must be removed so it does not show
      // the next time the message is shown
      const actionContainer = this.element.querySelector('.js-toast-message-action');
      actionContainer.innerHTML = '';
      actionContainer.classList.add('hidden');
      this.element.classList.add('hidden');
      return false;
    }

    this.element.remove();
  }

  _removeFromEvent() {
    this._setTimeoutForRemove();
  }

  _setTimeoutForRemove() {
    window.setTimeout(() => {
      this.remove();
    }, 5000);
  }
}
